import { z } from 'zod';

import { CandidateReputationClarificationSchema } from './candidate-reputation-clarification';

export const CandidateReputationClarificationPatchSchema = z.object({
  candidateId: z.string().uuid(),
  candidateReputationClarification: CandidateReputationClarificationSchema.pick(
    { submissionComments: true, id: true }
  ),
});

export type CandidateReputationClarificationPatch = z.infer<
  typeof CandidateReputationClarificationPatchSchema
>;
